import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { useAuthStore } from 'app/stores/StoreContext'

/**
 * Dark mode is available when the `dark-mode` feature toggle is on, or the
 * signed-in user is a super admin (super admins always see it, everyone else
 * needs the toggle). Callers must be wrapped in `observer()`.
 */
export function useDarkModeAvailable(): boolean {
  const toggleEnabled = useFeatureToggle(`dark-mode`)
  const auth = useAuthStore()
  return toggleEnabled || auth.isSuper
}
